'use strict';

import './SocialReviews.less';

import _ from 'lodash';
import React from 'react';
import lang from './SocialReviewsLang';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

export default class SocialReviews extends React.Component {
	componentDidMount() {}

	render() {
		let headerLang = lang[this.props.langKey];

		const reviewsLang = [
			{
				author: 'Sherry-Ann',
				time: '3 hours ago',
				title: 'Best program and fantastic support team',
				copy:
					'My son has learnt so much using the program. He is now creating codes for his older brothers so they can play together. Customer service is amazing, we had a few problems to begin with not the system just my son making small code errors but the support team were amazing with him. Talking him though ideas and coaching him about value of making errors and learning how to correct them. I highly recommend CK'
			},
			{
				author: 'Peter Schofield',
				time: '18 hours ago',
				title: 'My daughter is a big fan of this…',
				copy:
					"My daughter is a big fan of this program. She's wanted to mod Minecraft for a while and I've been meaning to create a Java server, but CK does it all for you without any hassle. She particularly likes Lara's coding course videos, they're very funny! We might try the Roblox coding too in the future..."
			},
			{
				author: 'Gorst S',
				time: '1 day ago',
				title: 'Both my boys love it',
				copy:
					'Both my boys love it - intuitive and give them a fair bit of choice on how and what they created b their games - they absolutely adore it ( & learn in the process ) !'
			},
			{
				author: 'Dani Eichhorn',
				time: '3 hours ago',
				title: 'The best option for young coding',
				copy: `The best option for coding if you're young. I really love the way they explain the code and what you have to do to reach that. From all the coding for kids courses is this the most child-friendly to learn and understand. I've got nothing else to say except: Give it a try!`
			},
			{
				author: 'Sean Mohrhoff',
				time: '3 hours ago',
				title: 'Stellar Customer Service!',
				copy: `I saw an ad offering a lifetime membership back in 2020 and my child had just turned 6. When broached by my mother as to what to gift her grand daughter, I suggested this. However, my daughter was still too flighty to sit down and code, so we saved it on the back burner. Then in 2021, my mother passed before disclosing the gift code to redeem the game and we have forgotten about it until yesterday when she actually declared an interest for coding her own games. Suffice to say I had no way to look up the account info on my own so I wrote the company and enclosed the paid receipt for the game as well as documentation regarding my mother and Ross, one of the support specialists here, helped me with a renewed account link. We are very grateful as this was something my mother wanted to give my child.

					Thank you, Ross, for fulfilling my daughter's grandmother's final gift. It means a lot to my wife, myself and my daughter who misses her "abuelita" very much.`
			},
			{
				author: 'Carrie O',
				time: '1 day ago',
				title: 'These people are great',
				copy:
					"These people are great. They really care what you're happy and that your kids are happy and enjoying the program."
			},
			{
				author: 'Abhi',
				time: '2 days ago',
				title: 'Loved CodeKingdom',
				copy:
					'Got CodeKingdom for my daughter. She loves it. She was enagaged due to the fact that it has coding for Roblox and she loves Roblox. Also the support was brilliant'
			},
			{
				author: 'Victoria Moisevici',
				time: '3 days ago',
				title: 'Really good platform',
				copy:
					'My 9 years old son really enjoy to code with Code Kingdoms, especially because it’s connected with Minecraft. Explanations of methods, variables are very accessible. You can immediately see the implementation of the code, which is also a large +. Really good platform.'
			},
			{
				author: 'Brian',
				time: '3 days ago',
				title: 'Good customer service',
				copy:
					'I messed up while registering a new account, sent an email to see what went wrong. Somebody answered the email promptly, and fixed my issue. It was a seamless experience, and the help was appreciated'
			},
			{
				author: 'Predrag Jaksic',
				time: '5 days ago',
				title: 'Great company and great support',
				copy:
					'Excellent product and very responsive customer service. Had an issue and reported it on Sunday. I had the response pretty much immediately and everything was sorted.'
			},
			{
				author: 'Eve Scott',
				time: '5 days ago',
				title: 'Code Kingdoms are a fantastic company',
				copy: `Code Kingdoms are a fantastic company. They're always happy to help and provide great content with lots of nice features for kids. They are committed to their customers and have a great interface for keeping track of your progress.`
			},
			{
				author: 'Indi Tonehouse',
				time: '5 days ago',
				title: 'Happy lifetime member',
				copy: `My daughter loves code kingdoms as their program is easy to use. I love it because their customer service is great. Anytime I’ve not been able to work something out they’ve helped get it sorted. We’ve recently upgraded to the lifetime membership for both programs.`
			},
			{
				author: 'Lena S',
				time: '5 days ago',
				title: 'Happy lifetime member',
				copy: `I am very impressed with the great customer service. I had bought Code Kingdoms last year but never got to try it out with my son due to a series personal events. I had only noticed when I had received an email from CK that my subscription will renew soon. This is a first big plus - I love that they reminded me about this. I then enquired whether I could get a refund for last year at all as I hadn’t been able to use it. Ross was very quick to reply and kindly offered to provide an account credit instead. Especially given that I was 11 months over the refund window, this is a very generous offer.
					I can now use CK when things have calmed down at our end. Ross also proactively cancelled my auto-renewal. All in all, a surprisingly pleasant customer experience. I felt heard and understood and treated like a human - thank you very much for this!`
			},
			{
				author: 'Clint Rule',
				time: '5 days ago',
				title: 'Code Kingdoms understanding and generosity',
				copy: `Code Kingdoms showed me great understanding and generosity when I needed my membership extended for the product I purchased from them.`
			}
		];

		const reviews = [];

		_.each(reviewsLang, (review, reviewKey) => {
			reviews.push(
				<div className="trustpilotItem" key={reviewKey}>
					<div className="top">
						<ReactCKImage name="trustpilot-stars" forceImgTag={true} />
						<div className="author">
							by <span className="bold">{review.author}</span>
						</div>
						{/* <div className="time">{review.time}</div> */}
					</div>
					<div className="review">
						<div className="reviewTitle">{review.title}</div>
						<div className="reviewCopy">{review.copy}</div>
					</div>
				</div>
			);
		});

		return (
			<div className={`SocialReviews ${this.props.showThumb ? '' : 'noThumb'}`}>
				<ReactCKImage
					name="generic-white-cloud"
					forceImgTag={true}
					extraClasses={['cloudRightTop']}
				/>
				<ReactCKImage
					name="generic-white-cloud"
					forceImgTag={true}
					extraClasses={['cloudRightBottom']}
				/>

				{this.props.showThumb && (
					<ReactCKImage name="social-reviews-pipe" forceImgTag={true} extraClasses={['pipe']} />
				)}

				<ReactCKImage name="social-reviews-bottom" forceImgTag={true} extraClasses={['bottom']} />

				<div className="maxWidthContentWrapper">
					{this.props.showThumb && (
						<ReactCKImage name="social-reviews-thumb" forceImgTag={true} extraClasses={['thumb']} />
					)}

					<div className="content">
						{/* <div className="title">{headerLang.TITLE}</div> */}

						<div className="trustpilotTopBox">
							<div className="scoreName">Excellent</div>
							<ReactCKImage
								name="trustpilot-stars-summary"
								forceImgTag={true}
								extraClasses={['stars']}
							/>
							<div>
								<a href="https://uk.trustpilot.com/review/codekingdoms.com">
									<div className="summary">See all our reviews on </div>{' '}
									<ReactCKImage
										name="trustpilot-score"
										forceImgTag={true}
										extraClasses={['logo']}
									/>
								</a>
							</div>
						</div>

						{reviews}

						{/* {this.props.children} */}
					</div>
				</div>
			</div>
		);
	}
}

SocialReviews.propTypes = {
	langKey: PropTypes.string.isRequired,
	showThumb: PropTypes.bool,
	children: PropTypes.node
};
